import * as mutationTypes from './mutation-types'

const Attachments = {
  state() {
    return {
      attachments: {},
    }
  },

  getters: {
    attachmentArray: (state) => Object.values(state.attachments),
  },

  mutations: {
    [mutationTypes.SET_ATTACHMENTS](state, attachments) {
      state.attachments = attachments
    },

    [mutationTypes.DELETE_ATTACHMENT](state, { comment, id }) {
      const index = comment.attachmentIds.indexOf(id)

      comment.attachmentIds.splice(index, 1)
      delete state.attachments[id]
    },
  },

  actions: {
    deleteAttachment({ commit, getters }, [commentId, id]) {
      const comment = getters.commentById(commentId)
      commit(mutationTypes.DELETE_ATTACHMENT, { comment, id })
    },
  },
}

export default Attachments
